import styled from 'styled-components'

export const Title = styled.div`
  color: #213f68;
  font-size: 20px;
  font-weight: 700;
`

export const Description = styled.div`
  margin: 24px 0;
  color: #363636;
  a {
    color: #2684ff;
    display: initial;
    padding-left: 5px;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
`

export const Options = styled.span`
  button {
    background-color: #f0f0f0 !important;
    border-radius: 8px;
    width: 32px;
    padding-left: 13px;
    color: #4c4c4c !important;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`
